import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getFavorites, getTitleById } from "@/utils/catalog";
import { SectionTitle } from "@/components/base/Rating";

export default function FavoritesShelf() {
  const [ids, setIds] = useState<string[]>([]);

  useEffect(() => {
    setIds(getFavorites());
    const sync = () => setIds(getFavorites());
    window.addEventListener("storage", sync);
    window.addEventListener("cc-favorites-changed", sync);
    return () => {
      window.removeEventListener("storage", sync);
      window.removeEventListener("cc-favorites-changed", sync);
    };
  }, []);

  const favs = ids
    .map((id) => getTitleById(id))
    .filter((item): item is NonNullable<typeof item> => Boolean(item));

  return (
    <section className="w-full px-4 md:px-6 pt-14 md:pt-20" id="favorites">
      <SectionTitle
        accentLabel="My Shelf"
        title="我的收藏"
        subtitle="收藏的影片会保存在当前浏览器中，方便随时回来接着看。"
      />

      {favs.length === 0 ? (
        <div className="rounded-lg border border-dashed border-background-300 bg-background-100 px-6 py-10 text-center">
          <div className="w-12 h-12 mx-auto rounded-full bg-background-50 border border-background-200 flex items-center justify-center text-foreground-400 text-xl mb-3">
            <i className="ri-bookmark-line" />
          </div>
          <p className="text-sm text-foreground-700">还没有收藏任何影片</p>
          <p className="mt-1 text-xs text-foreground-500">
            在影片详情页点击「收藏」，就会出现在这里。数据仅保存在本地浏览器。
          </p>
          <Link
            to="/category/movie"
            className="mt-5 inline-flex items-center h-9 px-4 rounded-md bg-primary-500 text-background-50 text-xs font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            去逛逛电影
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-6 gap-3 md:gap-4">
          {favs.map((item) => (
            <Link
              key={item.id}
              to={`/detail/${item.id}`}
              className="group flex items-center gap-3 p-2 rounded-lg bg-background-50 border border-background-200 hover:border-secondary-400 transition-colors cursor-pointer"
            >
              <div className="w-12 h-16 rounded overflow-hidden bg-background-200 shrink-0">
                <img
                  src={item.cover}
                  alt={`${item.title} 海报`}
                  title={`${item.title} - CC视频`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="min-w-0">
                <p className="text-xs md:text-sm font-medium text-foreground-950 truncate group-hover:text-accent-600 transition-colors">
                  {item.title}
                </p>
                <p className="mt-0.5 text-[11px] text-foreground-500 truncate">
                  {item.genres[0]} · {item.year}
                </p>
              </div>
            </Link>
          ))}
        </div>
      )}
    </section>
  );
}